import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AspspsList from './components/AspspsList';
import FullTerms from './components/FullTerms';
import PrivacyPolicy from './components/PrivacyPolicy';
import StartScreen from './components/StartScreen';
import Kyc from './components/Kyc';
import BankConnection from './components/BankConnection';
import KycComplete from './components/KycComplete';
import KycWaiting from './components/KycWaiting';
import BankConnected from './components/BankConnected';
import SelectScaMethod from './components/SelectScaMethod';
import SigningStatus from './components/SigningStatus';
import PickAccount from './components/PickAccount';
import SummaryPage from './components/SummaryPage';
import { useTokenHandler } from './hooks/useTokenHandler';
import { TranslationProvider } from './context/TranslationContext';

// Wrapper component that handles token extraction inside Router context
function TokenHandler({ children }) {
  useTokenHandler();
  return children;
}

function App() {
  return (
    <Router>
      <TokenHandler>
        <TranslationProvider>
        <Routes>
          <Route path="/aspspsList" element={<AspspsList />} />         
          <Route path="/terms-full" element={<FullTerms />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />}></Route>
          <Route path='/' element={<StartScreen />}></Route>
          <Route path='/kyc' element={<Kyc />}></Route>
          <Route path='/kyc-waiting' element={<KycWaiting />}></Route>
          <Route path="/bank-connection" element={<BankConnection />} />
          <Route path="/kyc-complete" element={<KycComplete />} />
          <Route path="/bank-connected" element={<BankConnected />} />
          <Route path="/select-method" element={<SelectScaMethod />} />
          <Route path="/sign-status" element={<SigningStatus />} />
          <Route path="/pick-account" element={<PickAccount />} />
          <Route path="/summary" element={<SummaryPage />} />
        </Routes>
        </TranslationProvider>
      </TokenHandler>
    </Router>
  );
}

export default App;